import { useCallback, useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { Draggable } from "react-drag-reorder";
import { changePositionOnDrag, prioratiseItems, sortAlphabetically } from "../../../../common-functions/commonFunctions";
import { cloneDeep } from "../../../../constants/commonConstants";
import { getAlertData } from "../../../../helper/sweet-alert";
import { setButtons } from "../../../../store/slices/master/buttonSlice";
import { IButtonData, IUpdateButtonPriority } from "../../../../models/master/buttons";
import { getAllButtons, updateButtonPriority } from "../../../../action/masters/buttonActionCreator";
import LoaderSpinner from "../../../../common-components/loader";
import { UserRole } from "../../../../constants/RoleEnum";
import { masterType } from "../../../../constants/masterTypes";
import { setColleges, setPageBlocks } from "../../../../store/slices/common/commonSlice";
import FloatingLabelDropDown from "../../../../common-components/floatingdropdown";
import { getColleges, getUserPageBlocks } from "../../../../action/common/commonActionCreator";

const PriorityButtons = (props: IUpdateButtonPriority) => {
  const { updateButtonPriority, getButtons, buttons, configUserRole, getColleges, colleges, getUserPageBlocks, pageBlocks, currentRole, currentCollege } = props;
  const [filteredItems, setfilteredItems] = useState<any[]>([]);
  const [loader, setLoader] = useState(true);
  const [alertType, setAlertType] = useState<any>("success");
  const [alertTitle, setAlertTitle] = useState<string>("Default");
  const [selectedCollege, setSelectedCollege] = useState<any>(null);
  const [selectedPageBlock, setSelectedPageBlock] = useState<any>(null);
  const dispatch = useDispatch();

  const saveChangedPos = async (currentPos: any, newPos: any) => {
    if (currentPos != newPos) {
      setLoader(true);
      let _items = changePositionOnDrag(filteredItems, currentPos, newPos);
      await setfilteredItems(_items);
      updateButtonPriority(_items, setAlert);
    }
  };

  const ChangeVisibleOrNot = async (id: number, _displayOrNot: boolean) => {
    /////method 1
    setLoader(true);
    let index = filteredItems.findIndex((x) => x.id == id);
    let _afterFilteration = [];
    let _filteredItems = [...filteredItems];
    let selectedItem = _filteredItems.splice(index, 1);
    selectedItem[0].displayOrNot = _displayOrNot;

    selectedItem[0].priority = null;
    _afterFilteration = [
      ...prioratiseItems(_filteredItems.filter((x) => x.displayOrNot == true)),
      ...selectedItem,
      ..._filteredItems.filter((x) => x.displayOrNot == false),
    ];
    let _items = prioratiseItems(_afterFilteration);

    setfilteredItems([..._items]);
    updateButtonPriority(_items, setAlert);

    /////method 2
    // let _filteredItems = [...filteredItems]
    // let item = _filteredItems[index];
    // item.displayOrNot = __displayOrNot;
    // _filteredItems[index] = item;
    // updateAppPriority(item, setAlert);
    // setFilteredItems(_filteredItems);
  };

  const setAlert = (type: string) => {
    let alertData = getAlertData(type);
    if (alertData) {
      setLoader(false);
      setAlertType(alertData.type);
      setAlertTitle(alertData.title);
    }
  };

  const getAllButtons = async (configUserRoleId: number, pageBlockId?: number, collegeId?: number) => {
    setLoader(true)
    try {
      await getButtons(configUserRoleId, pageBlockId, collegeId);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    if (colleges && colleges?.length > 0) {
      const defaultCollegeId = colleges[0]?.id;
      setSelectedCollege(defaultCollegeId);
    }
    else {
      setSelectedCollege(currentCollege);
    }

    if (pageBlocks && pageBlocks.length > 0) {
      const defaultPageBlockId = pageBlocks[0]?.id;
      setSelectedPageBlock(defaultPageBlockId);
    } else {
      setSelectedPageBlock(null);
    }
  }, [colleges, pageBlocks]);

  useEffect(() => {
    if (selectedCollege && selectedPageBlock) {
      getAllButtons(configUserRole, selectedPageBlock, selectedCollege);
    }
    else if (!pageBlocks || pageBlocks.length === 0) {
      setfilteredItems([]);
      setLoader(false);
    }
  }, [selectedCollege, selectedPageBlock]);

  useEffect(() => {
    buttons && setfilteredItems(cloneDeep(buttons));
  }, [buttons]);

  useEffect(() => {
    if (currentRole == UserRole.SuperAdmin) {
      getColleges && getColleges();
    }
    getUserPageBlocks(configUserRole, masterType.button);
    return () => {
      dispatch(setButtons([]));
      dispatch(setColleges([]));
      dispatch(setPageBlocks([]));
    };
  }, [configUserRole]);

  const onSelectionChange = useCallback((e: any) => {
    if (e.target.name === "college") {
      setSelectedCollege(e.target.value);
    } else if (e.target.name === "pageBlock") {
      setSelectedPageBlock(e.target.value);
    }
  }, []);



  return (
    <>
      <div className="admincontent">
        <div className="title">
          <h2>Buttons</h2>
        
        <div className="side-filter d-flex justify-content-end w-50">
        {currentRole == UserRole.SuperAdmin &&
          <div className="col-md-6">
            <FloatingLabelDropDown
              label="University Management"
              placeholder=""
              onChange={(e: any) => onSelectionChange(e)}
              isMandatory={false}
              value={selectedCollege}
              name="college"
              optionsList={sortAlphabetically(colleges)}
              showClear={false}
            />
          </div>
        }
        <div className="col-md-6">
          <FloatingLabelDropDown
            label="Page-Block"
            placeholder=""
            onChange={(e: any) => onSelectionChange(e)}
            isMandatory={false}
            value={selectedPageBlock}
            name="pageBlock"
            optionsList={sortAlphabetically(pageBlocks)}
            showClear={false}
          />
        </div>
        </div>
        </div>
        <ul className="d-flex gap-3 flex-wrap mt-28">
          {loader ? (
            <LoaderSpinner />
          ) : filteredItems && filteredItems?.length > 0 ? (
            <>
              <Draggable
                onPosChange={async (currentPos, newPos) => {
                  await saveChangedPos(currentPos, newPos);
                }}
              >
                {filteredItems
                  .filter((item: IButtonData) => item.displayOrNot)
                  .map((button: IButtonData, index: number) => (
                    <li className="admin-card">
                      <div className="top">
                        <span className="handle">
                          <img src="/assets/images/drag.svg" />
                        </span>
                        <span className="counter">{button.priority}</span>
                        <div className="form-checkbox">
                          <input
                            type="checkbox"
                            checked={button.displayOrNot}
                            id={button.priority + "button"}
                            onChange={() => {

                              ChangeVisibleOrNot(
                                button.id ?? 0,
                                !button.displayOrNot
                              );
                            }}
                          />
                          <label htmlFor={button.priority + "button"}></label>
                        </div>
                      </div>
                      <div className="btm">
                        <h2>{button.name}</h2>
                      </div>
                    </li>
                  ))}
              </Draggable>
              {filteredItems
                .filter((item: IButtonData) => !item.displayOrNot)
                .map((button: IButtonData, index: number) => (
                  <li className="admin-card">
                    <div className="top">
                      <span className="handle">
                        <img src="/assets/images/drag.svg" />
                      </span>
                      <span className="counter">{ }</span>
                      <div className="form-checkbox">
                        <input
                          type="checkbox"
                          checked={button.displayOrNot}
                          id={button.priority + "button"}
                          onChange={() => {

                            ChangeVisibleOrNot(
                              button.id ?? 0,
                              !button.displayOrNot
                            );
                          }}
                        />
                        <label htmlFor={button.priority + "button"}></label>
                      </div>
                    </div>
                    <div className="btm">
                      <h2>{button.name}</h2>
                    </div>
                  </li>
                ))}
            </>
          ) : (
            <p>No Records Found</p>
          )}
        </ul>
      </div>
    </>
  );
};
const mapDispatchToProps = {
  updateButtonPriority: (data: any, callBack: Function) => updateButtonPriority(data, callBack),
  getButtons: (configUserRole: number, pageBlockId?: number, collegeId?: number) => getAllButtons(configUserRole, pageBlockId, collegeId),
  getColleges: () => getColleges(),
  getUserPageBlocks: (userType: number, masterType: string) => getUserPageBlocks(userType, masterType),
};

function mapStateToProps(state: any) {
  return {
    buttons: state.button.buttons,
    colleges: state.common.colleges,
    pageBlocks: state.common.pageBlocks,
    currentRole: state.userDetails.userProfileData?.currentRole,
    currentCollege: state.userDetails.userProfileData?.currentCollege?.id,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PriorityButtons);
